import React from "react";
import { Flex, Text, Code, Box, Container, Separator, Heading, Badge, Blockquote } from "@radix-ui/themes";

const Privacy: React.FC = () => {
  return (
    <Box>
	<Container size="2">
        <Flex direction="column" gap="4" px="4" py="9">

            <Heading size="8">Privacy Policy</Heading>
            <Heading size="4" weight="regular">Live Football On TV Android App</Heading>
            <Flex direction="row">
              <Text size="2">Last Updated: </Text> 	<Badge color="green">1 September 2025</Badge>
            </Flex>

            <Separator my="3" size="4" />

        <Heading size="5">
          Introduction
        </Heading>
        <Text size="3">
          Welcome to our Privacy Policy! We strive to collect as little data as possible when you use our service. We will only ask for personal information when we truly need it to provide a service to you and we will collect it in a fair and lawful manner. Fundamentally, your privacy is important to us.
        </Text>
        <Text size="3">
          This Privacy Policy gives you an overview of the data we collect and how it will be used.
        </Text>

        <Heading size="5">
          Contact
        </Heading>
        <Text size="3">
          The developer Patrick Millais (“us”, “we”, or “our”) operates the Live Football On TV Android app (the “service”). Please use the one of the options below if you have a contact query:
        </Text>
        <Text size="3">
          <Text weight="bold">Email: </Text>
          <Code>patrickmillais@gmail.com</Code>
        </Text>
        <Text size="3">
          <Text weight="bold">X: </Text>
          <Code>@Millais</Code>
        </Text>

        <Heading size="5">
          The Type Of Information We Collect
        </Heading>
        <Text size="3">
          This section sets out the type of personal information which we currently collect to operate the service. The following section will contextualise how and why this personal information is collected.
        </Text>
        <Text size="3">
          We do not collect personal data from you before you create an account on our service.
        </Text>
        <Text size="3">
          When you register for an account on our service, we will collect and process a minimal amount of personal data in order to create and operate your account.
        </Text>
        <Text size="3">
          For the purposes of this privacy policy, we will separate <Text size="3"><em>directly identifiable personal data</em></Text> (information that by itself directly identifies an individual) and <Text size="3"><em>indirectly identifiable personal data</em></Text> (information that does not directly identify an individual, but combined with other information may lead to identification).
        </Text>
        <Text size="3">
          The service collects the following directly identifiable personal data:
        </Text>

        <ul>
            <li>A unique identifier from a federated identity provider (e.g a Google ID)</li>
            <li>Your Name</li>
            <li>Your Email</li>
            <li>Your Profile Picture (if you have one)</li>
        </ul>
        <Text size="3">
          The service collects the following indirectly identifiable personal data:
        </Text>
        <ul>
            <li>Teams, competitions, channels and matches you follow and/or hide (if you configure these)</li>
            <li>Your notification preferences: teams, competitions, channels and matches (if you configure these)</li>
        </ul>
        <Heading size="5">
          Personal Data: The How And Why
        </Heading>
        <Heading size="4">
          How We Collect Personal Data
        </Heading>
        <Text size="3">
          We collect personal data when you register for an account or become a supporter on our service. Currently the service only allows you to create an account using a federated identity provider. The identity providers supported currently are:
        </Text>
        <ul>    
        <li> Google Sign-in</li>
        </ul>
        <Text size="3">
          You will provide permission for the identity provider to share your personal data with us.
        </Text>
        <Heading size="4">
          How And Why We Use Your Personal Data
        </Heading>
        <Text size="3">
          Your personal data will be securely transmitted to the service in order for your account to be created and maintained. We only collect this data through our service when we have a valid reason and the legal grounds to do so.
        </Text>
        <Text size="3">
          We use this minimal amount of personal data to provide account-related functionality and improve the service.
        </Text>
        <Text size="3">
          The legal grounds for using your data may be one of the following:
        </Text>

        <ul>
            <li><Text weight="bold">Contract: </Text>When you have created an account for a personalised app experience and your personal data is required for the service to operate as described. For example: for the service to offer a personalised schedule of your favourite teams/competitions/channels, to synchronise notification preferences across your devices etc.</li>
            <li><Text weight="bold">Legitimate Interests: </Text>Your personal data may be required to provide ongoing operations related to the service in an efficient manner. For example: account-related support and queries. Additionally, your personal data is used to personalise your account for display in the service in a specific and limited way. For example: providing a name and profile picture on account-related app pages.</li>
        </ul>

        <Heading size="3">
          Sharing Your Personal Data
        </Heading>
        <Blockquote>
          With other Live Football On TV services
        </Blockquote>
        <Text size="3">
          Your personal data is currently used to operate and run the service specified in this Privacy Policy – specifically the Live Football On TV Android app. We reserve the right to share your personal data with other Live Football On TV services in the future including the parties operating the Live Football On TV iOS app and website.
        </Text>
        <Blockquote>
          With service providers
        </Blockquote>
        <Text size="3">
          Your personal data may be shared with other organisations that provide services on our behalf. Specific examples include:
        </Text>
        <ul>
            <li>Internet & Cloud Hosting Service Providers. <Text size="3"><em>Examples:</em></Text> Google Cloud, Firebase, Amazon Web Services.</li>
            <li>Error Tracking Software: <Text size="3"><em>Examples:</em></Text> Sentry, Google Firebase.</li>
        </ul>
        <Text size="3">
          We share your personal data with these organisations in order to provide the service to you and to help us find and fix any errors with the service.
        </Text>
        <Blockquote>
          Law Enforcement
        </Blockquote>
        <Text size="3">
          We may disclose your personal information when reasonably required to do so by law enforcement agencies, regulators or government authorities in order to meet legal and/or regulatory obligations.
        </Text>
        <Blockquote>Acquisition/Merger/Sale</Blockquote>
        <Text size="3">
          In the event that Live Football On TV services including those covered by this Privacy Policy are merged, acquired, or involved in an asset sale, your data may be transferred.
        </Text>

        <Heading size="5">
          Security
        </Heading>
        <Text size="3">
          The security of your personal data is important to us. We strive to use commercially acceptable means to protect your personal data. However, no method of data transmission or storage is 100% secure and we cannot guarantee its absolute security.
        </Text>

        <Heading size="5">
          How Long We Keep Your Personal Data
        </Heading>
        <Text size="3">
          We keep your personal data for as long as we need to in order to provide the service to you.
        </Text>
        <Text size="3">
          If you no longer need the service, or you no longer wish us to hold your personal data, you may request its deletion through the service by opting to delete your account. In this case, your account will be deleted from our active databases immediately. Your personal data may be retained in our backup system until it is overwritten according to the service’s backup schedule – for a maximum of 60 days. <Text size="3"><em>Note:</em></Text> In practice your personal data will be removed from the backup system in a matter of days.
        </Text>

        <Heading size="5">
          International Data Transfer
        </Heading>
        <Text size="3">
          Personal data collected through the service may be stored, processed and transferred to computers outside of your local jurisdiction by our service providers. Note that the data protection laws in these locations may differ from your local jurisdiction. Because the service is primarily targeted at a UK audience, we strive to keep your personal data as close as possible to where you will likely be located in order to reduce network latency. Our service providers (such as Google Cloud) are therefore configured to the European region and specifically Western Europe zones.
        </Text>

        <Heading size="5">
          Third Party Links
        </Heading>
        <Text size="3">
          Our service may contain links to other websites, apps or services that are not operated by us. We advise you to review the Privacy Policy of every website, app or service you visit, as we have no control over the content, practices or privacy policies of these third parties, and we do not assume responsibility for their content.
        </Text>

        <Heading size="5">
          Your Data Protection Rights
        </Heading>
        <Text size="3">
          Under data protection law, you have rights including:
        </Text>

        <ul>
            <li><Text weight="bold">Your right of access:</Text> You have the right to ask us for copies of your personal information.</li>
            <li><Text weight="bold">Your right to rectification:</Text> You have the right to ask us to rectify personal information you think is inaccurate. You also have the right to ask us to complete information you think is incomplete.</li>
            <li><Text weight="bold">Your right to erasure:</Text> You have the right to ask us to erase your personal information in certain circumstances.</li>
            <li><Text weight="bold">Your right to restriction of processing:</Text> You have the right to ask us to restrict the processing of your personal information in certain circumstances.</li>
            <li><Text weight="bold">Your right to object to processing:</Text> You have the the right to object to the processing of your personal information in certain circumstances.</li>
            <li><Text weight="bold">Your right to data portability:</Text> You have the right to ask that we transfer the personal information you gave us to another organisation, or to you, in certain circumstances.</li>       
        </ul>

        <Text size="3">
          You are not required to pay any charge for exercising your rights. If you make a request, we have one month to respond to you. Please contact us using the details outlined earlier in this Privacy Policy if you wish to make a request or have any general queries around your personal data.
        </Text>

        <Heading size="4">
          Updates To This Privacy Policy
        </Heading>
        <Text size="3">
          We may update the Privacy Policy for this service from time to time. We will notify you of any changes by posting the new Privacy Policy to this webpage. You are advised to review this Privacy Policy periodically for any changes. Changes are effective immediately when they are posted to this webpage.
        </Text>
        <Text size="3">
          If a change in policy is significant or requires your permission, we will notify you (by email or in-app, depending on the change) to give you the opportunity to opt out of any new uses of your data.
        </Text>

        <Separator my="3" size="4" />
        <Text size="3"> Please contact us if you have any queries.</Text>
            
        </Flex>
	</Container>
</Box>

  );
};

export default Privacy;
